import EmailIcon from '@mui/icons-material/Email';
import React from 'react';

export const TemplatesIcon = ({
	bgColor = '#D4DCF5',
	width = 24,
	height = 24,
	...props
}) => {
	return (
		<EmailIcon
			{...props}
			sx={{
				backgroundColor: bgColor,
				width,
				height,
				borderRadius: 2,
				p: 0.5,
				color: '#fff',
			}}
		/>
	);
};
